export * from './styled.base';

export const fill = Styles.color.primary;
